var React = require('react');

function Clear (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8332 5.34169L14.6582 4.16669L9.99984 8.82502L5.3415 4.16669L4.1665 5.34169L8.82484 10L4.1665 14.6584L5.3415 15.8334L9.99984 11.175L14.6582 15.8334L15.8332 14.6584L11.1748 10L15.8332 5.34169Z","fill":"#ABBBCC"}));
}

Clear.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Clear;

Clear.default = Clear;
